import { render, staticRenderFns } from "./trabajadorEdita.vue?vue&type=template&id=74ac8b92&"
import script from "./trabajadorEdita.vue?vue&type=script&lang=js&"
export * from "./trabajadorEdita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports